import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Col, FlexboxGrid, Grid, Header, Row, Stack } from 'rsuite';
import {
  selectConfigExpressRegistrationVerbiage,
  selectConfigExpressSettingsLogo,
  selectConfigExpressSettingsName,
  selectConfigExpressTaxEnabled,
} from '../../store/slices/config/configSelectors';
import AccountDropdown from '../auth/AccountDropdown';
import usePlaceNavigate from '../../hooks/usePlaceNavigate';
import { FLOWS_ENUM } from '../../common/enums';
const PortalHeader = ({ showAccountDropdown = true, flow = '' }) => {
  const selectedLogo = useSelector(selectConfigExpressSettingsLogo);
  const selectedName = useSelector(selectConfigExpressSettingsName);

  const taxEnabled = useSelector(selectConfigExpressTaxEnabled);
  const regVerbiage = useSelector(selectConfigExpressRegistrationVerbiage);
  const place = useSelector(selectConfigExpressSettingsName);

  const placeNavigate = usePlaceNavigate();

  const title = useMemo(() => {
    switch (flow) {
      case FLOWS_ENUM.APPLY_LICENSE:
        return `${place} ${regVerbiage} Application`;
      case FLOWS_ENUM.RENEW_LICENSE:
      case FLOWS_ENUM.BULK_RENEWAL:
        return `${place} ${regVerbiage} Renewal`;
      case FLOWS_ENUM.UPDATE_CERTIFICATE:
        return `${place} Update ${regVerbiage}`;
      case FLOWS_ENUM.ADMIN_UPDATE:
        return `${place} Admin Update ${regVerbiage}`;
      case FLOWS_ENUM.PAY_TOT:
        return `${place} Pay Tax`;
      case FLOWS_ENUM.TAX_CERTIFICATE:
        return `${place} Tax Certificate Application`;
      default:
        return `${place} ${regVerbiage} ${taxEnabled ? `and Tax` : ''} Portal`;
    }
  }, [flow, place, taxEnabled, regVerbiage]);

  return (
    <Header
      as="header"
      className="m-0 p-0 top-banner"
    >
      <Grid
        role="grid"
        style={{ width: '100%' }}
      >
        <FlexboxGrid
          as={Row}
          align="middle"
          className="pv-8 sm-mt-0 sm-page-padding"
        >
          <FlexboxGrid.Item
            as={Col}
            className="header-contents-padding"
            colspan={19}
            sm={18}
            md={20}
            lg={18}
            align="middle"
          >
            <Stack
              direction="row"
              alignItems="center"
            >
              <img
                src={selectedLogo}
                alt={`Logo for ${selectedName}`}
                className="portal-header-town-img"
                style={
                  flow === FLOWS_ENUM.ADMIN_UPDATE
                    ? { cursor: 'default' }
                    : { cursor: 'pointer' }
                }
                {...(flow !== FLOWS_ENUM.ADMIN_UPDATE && {
                  onClick: () => placeNavigate('/dashboard'),
                })}
              />
              <h1 className="portal-header-title ml-8">
                {title && title.length > 0 ? `${title}` : ''}
              </h1>
            </Stack>
          </FlexboxGrid.Item>

          <FlexboxGrid.Item
            className="ph-24"
            as={Col}
            colspan={5}
            sm={6}
            md={4}
            lg={6}
            align="right"
          >
            {showAccountDropdown && <AccountDropdown />}
          </FlexboxGrid.Item>
        </FlexboxGrid>
      </Grid>
    </Header>
  );
};

export default PortalHeader;
